// High Index 
export const popUpIndex = 10;
export const responsiveMenuIndex = 4;
// Medium Index
export const graphicContainerIndex = 3;
export const patientMainDivIndex = 2;
export const patientSkinColorIndex = 2;
// Low Index
export const inputCheckboxIndex = 1;
export const relativeButtonIndex = 1;